export default "__VITE_ASSET__CStDEkrk__"